var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEquipmentPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 288,
    height: 108,
    viewBox: "0 0 288 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "#F7F7F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 101,
    y: 10.5,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "#CECEDA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M138.5 31.5V40.5H135.5V31.5C135.562 30.5625 136.062 30.0625 137 30C137.938 30.0625 138.438 30.5625 138.5 31.5ZM153.5 31.5V40.5H150.5V31.5C150.562 30.5625 151.062 30.0625 152 30C152.938 30.0625 153.438 30.5625 153.5 31.5ZM128 43.5H129.5H132.5H156.5H159.5H161C161.938 43.5625 162.438 44.0625 162.5 45C162.438 45.9375 161.938 46.4375 161 46.5H159.5V52.5C159.438 56.5 158.125 59.875 155.562 62.625C153.062 65.375 149.875 66.9688 146 67.4062V76.5C145.938 77.4375 145.438 77.9375 144.5 78C143.562 77.9375 143.062 77.4375 143 76.5V67.4062C139.125 66.9688 135.938 65.375 133.438 62.625C130.875 59.875 129.562 56.5 129.5 52.5V46.5H128C127.062 46.4375 126.562 45.9375 126.5 45C126.562 44.0625 127.062 43.5625 128 43.5ZM144.5 64.5C147.875 64.4375 150.719 63.2812 153.031 61.0312C155.281 58.7188 156.438 55.875 156.5 52.5V46.5H132.5V52.5C132.562 55.875 133.719 58.7188 135.969 61.0312C138.281 63.2812 141.125 64.4375 144.5 64.5Z",
    fill: "#706B85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEquipmentPlaceholder);
export default __webpack_public_path__ + "static/media/equipment-placeholder.f42c157b54f6248724ecdfb2c546ba83.svg";
export { ForwardRef as ReactComponent };